"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoDataMessage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const NoDataMessage = ({ tableStatus, isNothingFound, zeroResultMessage, noDataLabel, }) => {
    const message = React.useMemo(() => {
        if (tableStatus && tableStatus.statusCode > 0 && tableStatus.message && !isNothingFound) {
            return tableStatus.message;
        }
        else if (isNothingFound) {
            return zeroResultMessage;
        }
        else {
            return noDataLabel;
        }
    }, [noDataLabel, zeroResultMessage, isNothingFound, tableStatus]);
    return (0, jsx_runtime_1.jsx)("div", { className: "table--no-data w-full bg-[#ebebeb] px-[20%] py-3 text-center", children: message });
};
exports.NoDataMessage = NoDataMessage;
